import {
   IContentPool,
   IContentReference,
} from '../interfaces/campaign-v2.types'
export type ContentSlot =
   | 'outboundScripts'
   | 'inboundScripts'
   | 'humanScripts'
   | 'strategies'
   | 'conversationContent'
   | 'personas'
/** Keep replacement targets valid when a persona is copied, re-selected or removed. */
export const withPoolReferences = (
   pool: IContentPool,
   slot: ContentSlot,
   refs: IContentReference[],
   replaced?: { from: string; to: string }
): IContentPool => {
   const next = { ...pool, [slot]: refs }
   if (slot !== 'personas') return next
   const selected = new Set(refs.map((r) => r.id))
   const replacements = { ...pool.personaReplacements }
   if (
      replaced &&
      replaced.from !== replaced.to &&
      pool.personas?.some((r) => r.id === replaced.from)
   ) {
      for (const from of Object.keys(replacements))
         if (replacements[from] === replaced.from)
            replacements[from] = replaced.to
      replacements[replaced.from] = replaced.to
   }
   next.personaReplacements = Object.fromEntries(
      Object.entries(replacements).filter(
         ([from, to]) => !selected.has(from) && selected.has(to)
      )
   )
   if (!Object.keys(next.personaReplacements).length)
      delete next.personaReplacements
   return next
}
